<template>
  <div id="user-edit-tab-info">
    <div id="teacherCalendarLoadingDiv" class="vs-con-loading__container teacherCalDiv">
      <calendar-view
        ref="teacherCalendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="simpleCalendarEvents"
        @click-event="openEditEvent"
        :eventTop="windowWidth <= 400 ? '2rem' : '2.5rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"

   
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button class="mr-2" icon-pack="feather" icon="icon-rotate-cw" @click="refreshData()">Refresh</vs-button>
            </div>


            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                  </div>
                  <div class="flex items-center mr-4 mb-2">
                    <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                    <span>Teacher Bookings</span>
                  </div>
                  <div class="flex items-center mr-4 mb-2">
                    <div class="h-3 w-3 inline-block rounded-full mr-2" style="background-color: #860C5A;"></div>
                    <span>Student Bookings</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </calendar-view>

      <!-- ADD CALENDAR CLASS -->
      <vs-popup  classContent="popup-example h-full" title="Create Calendar" :active.sync="activePromptAddEvent">
        <div id="createEventLoadingDiv" class="vs-con-loading__container">
          <form data-vv-scope="addEventForm">
            <div class="vx-row mb-base">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <small class="date-label">Check in</small>
                <datepicker v-validate="'required'" name="date_from" ref="date_from" format="yyyy-MM-dd" :disabledDates="disabledDatesTo" v-model="createClubCalender.date_from" ></datepicker>
                <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.date_from')">{{ errors.first('addCalendarForm.date_from') }}</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <small class="date-label">Check out</small>
                <datepicker v-validate="'required'" name="date_to" ref="date_to" format="yyyy-MM-dd" :disabledDates="disabledDatesTo" v-model="createClubCalender.date_to"></datepicker>
                <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.date_to')">{{ errors.first('addCalendarForm.date_to') }}</span>
              </div>
            </div>

            <div class="vx-row mb-base">
              <div class="vx-col sm:w-full w-full mb-6">
                <span>Module</span>
                <v-select v-validate="'required'" name="clubModules" ref="clubModules" v-model="createClubCalender.clubModules" :options="eventOptions" />
                <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.clubModules')">{{ errors.first('addCalendarForm.clubModules') }}</span>
              </div>
            </div>

            <div align="right" class="vx-row">
              <div  class="vx-col w-full mb-2">
                <vs-button class="w-full" v-on:click.prevent="validateAddCalendarForm()" color="success" type="filled">Create Calendar</vs-button>
              </div>
            </div>
          </form>
        </div>
      </vs-popup>

      <!-- EDIT TEACHER CLASS -->
      <vs-popup classContent="popup-example h-full" title="Class Details" :active.sync="activePromptEditTeacherEvent">
        <div id="editTeacherCalenderLoadingDiv" class="vs-con-loading__container">
          <div class="vx-row" v-if="studentBooking.length">
            <div  class="vx-col w-full">
              <vs-list>
                <vs-list-header title="Students bookings" color="primary"></vs-list-header>
                <vs-list-item :title="singleStudentBooking.student.name+' '+singleStudentBooking.student.last_name" :subtitle="singleStudentBooking.time" v-for="(singleStudentBooking, index) in studentBooking">
                  <vs-chip class="ag-grid-cell-chip mt-6" color="danger" v-if="singleStudentBooking.attendance == 'Cancelled'">
                    <span>Cancelled</span>
                  </vs-chip>
                  <template slot="avatar">
                    <vs-avatar :src="'https://backend.tittam.com/public/images/users/'+singleStudentBooking.student.image" />
                  </template>
                </vs-list-item>
              </vs-list>
            </div>
          </div>

          <div class="vx-row" v-else>
            <div  class="vx-col w-full" style="min-width: 150px;">
              <vs-alert color="danger" title="No class" active="true" class="mt-3" style="min-width: 100px;">
                No bookings found yet
              </vs-alert>
            </div>
          </div>


          
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import { en, he } from "vuejs-datepicker/src/locale"
require("vue-simple-calendar/static/css/default.css")
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendarManagement from '@/store/calendar-management/moduleCalendarManagement.js'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    'v-select': vSelect,
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',

      langHe: he,
      langEn: en,

      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: "Month",
          val: "month"
        },
        {
          label: "Week",
          val: "week"
        },
        {
          label: "Year",
          val: "year"
        },
      ],
      classTypes: [
        {
          color: "success",
          text: "Teori",
          value: "teori"
        },
        {
          color: "warning",
          text: "Manøvre",
          value: "manøvre"
        },
        {
          color: "danger",
          text: "Glatbane",
          value: "glatbane"
        },
      ],
      options: [
        {id: 1, label: 'foo'},
        {id: 3, label: 'bar'},
        {id: 2, label: 'baz'},
      ],
      eventOptions: [
        {id: 'sick', label: 'Sick'},
        {id: 'holiday', label: 'Holiday'},
        {id: 'vacation', label: 'Vacation'},
        {id: 'leave', label: 'Leave'},
      ],

      
      
      createClubCalender : {
        class_location : null,
        number_of_students : 1,
        day : [],
        time_from : null,
        internalTeacher : null,
        externalTeacher : {
          name : "",
          email : "",
          phone : "",
        },
        clubModules : null,
        date_from : '',
        date_to : '',
        teacherType: {id: 1, label: 'Internal teacher'},
      },
      editClubCalenderData : null,
      editClubCalender : {
        class_location : null,
        number_of_students : 1,
        day : [],
        time_from : null,
        internalTeacher : null,
        externalTeacher : {
          name : "",
          email : "",
          phone : "",
        },
        clubModules : null,
        date_from : '',
        date_to : '',
        teacherType: {id: 1, label: 'Internal teacher'},
      },
      studentBooking : [],
      activePromptEditTeacherEvent : false,
    }
  },
  computed: {
    simpleCalendarEvents() {
      let calendarEvents = this.$store.state.calendarManagement.clubClasses
      return calendarEvents.filter(obj => { return obj.teacher_id == this.data_local.id})
    },
    validForm() {
      return this.title != '' && this.startDate != '' && this.endDate != '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
    },
    disabledDatesTo() {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom() {
      return { from: new Date(this.endDate) }
    },
    calendarLabels() {
      return this.classTypes
    },
    labelColor() {
      return (label) => {
        if (label == "teori") return "success"
        else if (label == "manøvre") return "warning"
        if (label == "glatbane") return "danger"
        if (label == "none") return "primary"
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    openEditEvent(event) {
      this.studentBooking = [];
      if(event.originalEvent.calendar_type && event.originalEvent.calendar_type == "teacher"){
        let data = { teacher_booking_id : event.originalEvent.id }
        const e = this.$store.getters['calendarManagement/getEvent'](event.id)
        if(e.student_bookings && e.student_bookings.length){
          for(var j = 0; j < e.student_bookings.length; j++){
            this.studentBooking.push(e.student_bookings[j])
          }
        }
          
        this.activePromptEditTeacherEvent = true;
      }
      else{
        const e = this.$store.getters['calendarManagement/getEvent'](event.id)
        if(e.teacher_booking && e.teacher_booking.length){
          for(var i = 0; i < e.teacher_booking.length; i++){
            if(e.teacher_booking[i].student_bookings && e.teacher_booking[i].student_bookings.length){
              for(var j = 0; j < e.teacher_booking[i].student_bookings.length; j++){
                this.studentBooking.push(e.teacher_booking[i].student_bookings[j])
              }
            }
          }
        }
        
        this.activePromptEditTeacherEvent = true;
      }
    },
    validateAddCalendarForm() {
      this.$validator.validateAll('addCalendarForm').then(result => {
        if (result) this.createNewClubCalender()
        else console.log(this.errors)
      })
    },
    createNewClubCalender() {
      var self = this
      this.$vs.loading({
        container: '#createClubCalenderLoadingDiv',
        scale: 0.6
      })

      if(this.createClubCalender.teacherType.id == 1) var teacher_data = { teacher_id : this.createClubCalender.internalTeacher.id }
      else if(this.createClubCalender.teacherType.id == 2) var teacher_data = { teacher_id : this.createClubCalender.externalTeacher.id }
      else{
        var teacher_data = {
          teacher_name : this.createClubCalender.externalTeacher.name,
          teacher_email : this.createClubCalender.externalTeacher.email,
          teacher_phone : this.createClubCalender.externalTeacher.phone,
        }
      }

      let data = {
        day : this.createClubCalender.day,
        class_location : this.createClubCalender.class_location,
        module_id : this.createClubCalender.clubModules.id,
        number_of_students : this.createClubCalender.number_of_students,
        time_from : this.createClubCalender.time_from.id,
        date_from : new Date(this.createClubCalender.date_from).toISOString().slice(0, 10),
        date_to : new Date(this.createClubCalender.date_to).toISOString().slice(0, 10),
      }

      this.$store.dispatch("calendarManagement/createClubCalender", Object.assign(data, teacher_data))
        .then(res => { 
          this.$vs.loading.close('#createClubCalenderLoadingDiv > .con-vs-loading')

          this.$vs.notify({
            title: "Success.",
            text: "Class created successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.$store.dispatch("calendarManagement/fetchClubClasses")
        })
        .catch(err => { 
          this.$vs.loading.close('#createClubCalenderLoadingDiv > .con-vs-loading')

          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
                scope: "addCalendarForm",
              });
            });
          }
        })
    },
    validateEditCalendarForm() {
      this.$validator.validateAll('editCalendarForm').then(result => {
        if (result) this.editSingleClubCalender()
        else console.log(this.errors)
      })
    },
    editSingleClubCalender() {
      var self = this
      this.$vs.loading({
        container: '#editClubCalenderLoadingDiv',
        scale: 0.6
      })

      if(this.editClubCalender.teacherType.id == 1) var teacher_data = { teacher_id : this.editClubCalender.internalTeacher.id }
      else if(this.editClubCalender.teacherType.id == 2) var teacher_data = { teacher_id : this.editClubCalender.externalTeacher.id }
      else{
        var teacher_data = {
          teacher_name : this.editClubCalender.externalTeacher.name,
          teacher_email : this.editClubCalender.externalTeacher.email,
          teacher_phone : this.editClubCalender.externalTeacher.phone,
        }
      }

      let data = {
        class_location : this.editClubCalender.class_location,
        module_id : this.editClubCalender.clubModules.id,
        number_of_students : this.editClubCalender.number_of_students,
        time_from : this.editClubCalender.time_from.id,

        date_from : this.editClubCalenderData.date_from,
        date_to : this.editClubCalenderData.date_to,
        day : [this.editClubCalenderData.day],
        club_calendar_id : this.editClubCalenderData.id,
      }

      this.$store.dispatch("calendarManagement/updateClubCalender", Object.assign(data, teacher_data))
        .then(res => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
          this.activePromptEditEvent = false;
          this.$vs.notify({
            title: "Success.",
            text: "Class updated successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.$store.dispatch("calendarManagement/fetchClubClasses")
        })
        .catch(err => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')

          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                scope: "editCalendarForm",
                msg: err.data[key][0],
              });
            });
          }
        })
    },
    cancelSingleClubCalender() {
      var self = this
      this.$vs.loading({
        container: '#editClubCalenderLoadingDiv',
        scale: 0.6
      })

      this.$store.dispatch("calendarManagement/cancelClubCalender", { club_calendar_id : this.editClubCalenderData.id})
        .then(res => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
          this.activePromptEditEvent = false;
          this.$vs.notify({
            title: "Success.",
            text: "Class cancelled successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.$store.dispatch("calendarManagement/fetchClubClasses")
        })
        .catch(err => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
        })
    },
    addEvent() {
        const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
        obj.classes = "event-" + this.labelColor(this.labelLocal)
        this.$store.dispatch('calendar/addEvent', obj);
    },
    updateMonth(val) {
      this.showDate = this.$refs.teacherCalendar.getIncrementedPeriod(val);
    },
    clearFields() {
        this.title = this.endDate = this.url = "";
        this.id= 0;
        this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
        this.disabledFrom = false;
        this.addNewEventDialog(date);
    },
    addNewEventDialog(date) {
        this.clearFields();
        this.startDate = date;
        this.createClubCalender.date_from = date;
        this.endDate = date;
        this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
      let currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      if(date > currentDate){
        this.disabledFrom = true;
        this.addNewEventDialog(date);
      }
    },
    editEvent() {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeEvent', this.id)
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged(event, date) {
      this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    },
    async refreshData() {
      this.$vs.loading({
        container: '#teacherCalendarLoadingDiv',
        scale: 0.6
      })

      await this.$store.dispatch("calendarManagement/fetchClubClasses")
        .then(res => { 
          this.$vs.loading.close('#teacherCalendarLoadingDiv > .con-vs-loading')
        })
        .catch(err => { 
          this.$vs.loading.close('#teacherCalendarLoadingDiv > .con-vs-loading')
        })

      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
        .then(res => { 
          
        })
        .catch(err => { 

        })
    }
  },
  async created() {
    // this.$store.registerModule('calendar', moduleCalendar)
    // this.$store.dispatch("calendar/fetchEvents")
    // this.$store.dispatch("calendar/fetchEventLabels")

    // Register Module UserManagement Module
    if(!moduleCalendarManagement.isRegistered) {
      this.$store.registerModule('calendarManagement', moduleCalendarManagement)
      moduleCalendarManagement.isRegistered = true
    }

    // Register Module UserManagement Module
    // if(!moduleUserManagement.isRegistered) {
    //   this.$store.registerModule('userManagement', moduleUserManagement)
    //   moduleUserManagement.isRegistered = true
    // }

    // await this.$store.dispatch("userManagement/fetchTeachers")
    // await this.$store.dispatch("userManagement/fetchIntenalExternalTeachers")
    // await this.$store.dispatch("calendarManagement/fetchClubModules")
    // await this.$store.dispatch("calendarManagement/fetchClubLocations")

    // this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
  },
  async mounted() {
    await this.$store.dispatch("calendarManagement/fetchClubClasses")
      .then(res => { 
        
      })
      .catch(err => { 

      })

    await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
      .then(res => { 
        
      })
      .catch(err => { 

      })
  },
  beforeDestroy() {
    // this.$store.unregisterModule('calendarManagement')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>

<style lang="css">
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

#createClubCalenderLoadingDiv{
  height: 100%;
  overflow: auto;
}

#editClubCalenderLoadingDiv{
  height: 100%;
  overflow: auto;
}

.cv-week {
  min-height: 5em;
}

.vdp-datepicker__calendar{
  position: absolute;
  top: 0px;
}

.cv-day-number{
  height : 25px !important;
}

.teacherCalDiv{
  height: 1000px !important;
}

.cv-event.event-primary {
    background: rgba(var(--vs-primary), 1) !important;
}
.cv-event.event-success {
    background: rgba(var(--vs-success), 1) !important;
}

.cv-event.event-warning {
    background: rgba(var(--vs-warning), 1) !important;
}

.cv-event.event-danger {
    background: rgba(var(--vs-danger), 1) !important;
}

.calEventStudentBooking{
  background-color: #860C5A !important;
}

.cv-event {
  color: #fff;
  font-weight: 500;
  cursor: pointer;
}

</style>
